export default function Spinner() {
    return (
        <>
            <span className="loader"></span>
        </>
    )
}